/**
 * 色盘
*/
const colorPalette = {
    release: "#333",
    scheduled: "#108ee9",
    actualRelease: "#87d068",
    timeout: "#FA8C16",
};

// const tableHeader = 88;
const tableHeader = 0;

// 表格大小常量
const rowSideLength = 31;

// 一天
const day = 1000 * 60 * 60 * 24;

// 一周
const week = day * 7;

const getBarColor = (type) => {
    return colorPalette[type];
};


// 假期时间
const holidaySetting = [
    {
        year: 2023,
        day: [
            {
                name: "春节",
                start: '2023-01-21',
                end: '2023-01-27',
                durationDate: 7,
                classFill: ['2023-01-28', '2023-01-29']
            },
            {
                name: "清明节",
                start: '2023-04-05',
                end: '2023-04-06',
                durationDate: 1,
                classFill: null
            },
            {
                name: "劳动节",
                start: '2023-04-29',
                end: '2023-05-03',
                durationDate: 5,
                classFill: ['2023-04-23', '2023-05-06']
            },
            {
                name: "端午节",
                start: '2023-06-22',
                end: '2023-06-24',
                durationDate: 3,
                classFill: ['2023-06-25']
            },
            {
                name: "中秋、国庆节",
                start: '2023-09-29',
                end: '2023-10-06',
                durationDate: 8,
                classFill: ['2023-10-07', '2023-10-08']
            },
            {
                name: "元旦",
                start: '2023-12-30',
                end: '2024-01-01',
                durationDate: 3,
                classFill: null
            }
        ]
    },
    {
        year: 2024,
        day: [
            {
                name: "元旦",
                start: '2023-12-30',
                end: '2024-01-01',
                durationDate: 3,
                classFill: null
            },
            {
                name: "春节",
                start: '2024-02-10',
                end: "2024-02-17",
                durationDate: 8,
                classFill: ['2024-02-04', '2024-02-18']
            },
            {
                name: "清明节",
                start: '2024-04-04',
                end: "2024-04-06",
                durationDate: 3,
                classFill: ['2024-04-07']
            },
            {
                name: "劳动节",
                start: '2024-05-01',
                end: "2024-05-05",
                durationDate: 5,
                classFill: ['2024-04-28', '2024-05-11']
            },
            {
                name: "端午节",
                start: '2024-06-08',
                end: '2024-06-10',
                durationDate: 3,
                classFill: null
            },
            {
                name: "中秋节",
                start: '2024-09-15',
                end: '2024-09-17',
                durationDate: 3,
                classFill: ['2024-09-14']
            },
            {
                name: "国庆节",
                start: '2024-10-01',
                end: '2024-10-07',
                durationDate: 7,
                classFill: ['2024-09-29', '2024-10-12']
            },
        ]
    }
];

export {
    day,
    week,
    tableHeader,
    colorPalette,
    rowSideLength,
    holidaySetting,
    getBarColor,
}
